'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeLeaderboard = exports.fetchLeaderboard = undefined;

var _client = require('../../utils/client');

var _params = require('../../utils/params');

var _justgiving = require('./justgiving');

var _everydayhero = require('./everydayhero');

/**
 * @function fetches pages ranked by funds raised
 */
var fetchLeaderboard = exports.fetchLeaderboard = function fetchLeaderboard() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return (0, _client.isJustGiving)() ? (0, _justgiving.fetchLeaderboard)(params) : (0, _everydayhero.fetchLeaderboard)(params);
};

/**
 * @function a default deserializer for leaderboard pages
 */
var deserializeLeaderboard = exports.deserializeLeaderboard = function deserializeLeaderboard(page, index) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.deserializeLeaderboard)(page, index) : (0, _everydayhero.deserializeLeaderboard)(page, index);
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/leaderboard/index.js
// module id = 219
// module chunks = 0